<template>
  <v-card>
    <v-card-title>
      <span class="text-h5">{{ app.name }}</span>
    </v-card-title>
    <v-card-text>
      <div v-if="error">
        <v-alert
          v-for="(e, index) in error.data.errors"
          :key="index"
          color="error"
          dark
          dense
        >
          {{ e[0] }}
        </v-alert>
      </div>
      <v-form
        v-if="app.settings"
        v-model="valid"
        @submit.prevent="updateSettings"
      >
        <v-select
          v-model="settings.status"
          :rules="rules.requiredSelect"
          :items="[
            'Ready to be built',
            'Internal testing',
            'Beta testing',
            'Production'
          ]"
          :label="`${$t('ITEM.STATUS')}`"
        ></v-select>

        <v-text-field
          v-model="bundle"
          :rules="rules.requiredField"
          :disabled="bundleDisabled"
          :label="`${$t('APPS.BUNDLE')}`"
        ></v-text-field>

        <v-textarea
          v-model="firebase_server_key"
          :rules="rules.textLine"
          :counter="255"
          rows="3"
          :label="`${$t('APPS.FIREBASE_SERVER_KEY')}`"
        ></v-textarea>

        <v-row dense>
          <v-col cols="6">
            <v-text-field
              v-model="settings.android_version"
              :rules="rules.requiredField"
              type="number"
              step="0.1"
              :label="`${$t('APPS.ANDROID_VERSION')}`"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="settings.android_build"
              :rules="rules.requiredField"
              type="number"
              :label="`${$t('APPS.ANDROID_BUILD')}`"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="6">
            <v-text-field
              v-model="settings.ios_version"
              :rules="rules.requiredField"
              type="number"
              step="0.1"
              :label="`${$t('APPS.IOS_VERSION')}`"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="settings.ios_build"
              :rules="rules.requiredField"
              type="number"
              :label="`${$t('APPS.IOS_BUILD')}`"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-checkbox
          v-model="settings.major"
          :label="this.$t('APPS.MAJOR_UPDATE')"
        ></v-checkbox>

        <v-text-field
          v-model="settings.emails"
          hint="services@bonacasa.ch; alexey.moroz@bonacasa.ch"
          :label="`${$t('APPS.EMAILS')}`"
        ></v-text-field>

        <v-text-field
          v-model="settings.emails_orders"
          hint="services@bonacasa.ch; alexey.moroz@bonacasa.ch"
          :label="`${$t('APPS.EMAILS_FOR_ORDERS')}`"
        ></v-text-field>

        <v-row justify="end" no-gutters>
          <v-col cols="auto">
            <slot name="buttons" />
            <v-btn
              color="primary"
              depressed
              type="submit"
              :disabled="!valid"
              @click="updateSettings"
            >
              {{ $t('BUTTON.SAVE') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
      <span v-else>
        {{ message }}
      </span>
    </v-card-text>
  </v-card>
</template>

<script>
import {
  requiredSelectArray,
  requiredSelectNotArray,
  textLine
} from '@/modules/_global/variables/rules.js';

export default {
  name: 'AppSettingsForm',

  props: {
    app: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      valid: true,
      error: null,
      settings: null,
      bundleDisabled: false,
      bundle: null,
      firebase_server_key: null,
      rules: {
        requiredField: requiredSelectNotArray, // … to not touch the rules.js file
        requiredSelect: requiredSelectNotArray,
        requiredMultiSelect: requiredSelectArray,
        textLine: textLine
      }
    };
  },

  computed: {
    message() {
      return this.$t('APPS.MESSAGE').replace(':app.name', this.app.name);
    }
  },

  created() {
    this.settings = { ...this.app.settings };
    this.bundle = this.app.bundle || '';
    this.firebase_server_key = this.app.firebase_server_key || '';
    this.bundleDisabled = this.bundle !== '';
  },

  methods: {
    updateSettings() {
      this.$store
        .dispatch('apps/updateSettings', {
          id: this.app.id,
          bundle: this.bundle,
          firebase_server_key: this.firebase_server_key,
          settings: this.settings
        })
        .then(() => this.$emit('updated'))
        .catch(error => {
          this.error = error.response;
        });
    }
  }
};
</script>
